/* Výběr dopravy a výdejního místa v košíku (mapa Zaslat.cz).
   Výběr se uloží do atributů košíku, takže je vidět u objednávky ve Shopify.
   Tlačítko „K pokladně“ je zablokované, dokud není vybraná doprava (a u výdejních míst i místo). */
(function () {
  'use strict';

  var METHODS = {
    cz: [
      { id: 'zasilkovna', name: 'Zásilkovna - výdejní místa / Z-box', short: 'Zásilkovna', carrier: 'zasilkovna', point: true, price: 69, free: true },
      { id: 'ppl_point', name: 'PPL - na výdejní místo', short: 'PPL', carrier: 'ppl', point: true, price: 59, free: true },
      { id: 'balikovna_point', name: 'Balíkovna/AlzaBox - výdejní místo', short: 'Balíkovna', carrier: 'balikovna', point: true, price: 69, free: true },
      { id: 'ppl_home', name: 'PPL - doručení na adresu', short: 'PPL', carrier: 'ppl', point: false, price: 89, free: false },
      { id: 'balikovna_home', name: 'Balíkovna - doručení na adresu', short: 'Balíkovna', carrier: 'balikovna', point: false, price: 89, free: false }
    ],
    sk: [
      { id: 'zasilkovna', name: 'Packeta - výdejné miesta / Z-box', short: 'Packeta', carrier: 'zasilkovna', logo: 'packeta', point: true, price: 3.49, free: true },
      { id: 'ppl_point', name: 'PPL - na výdejní místo', short: 'PPL', carrier: 'ppl', point: true, price: 3.49, free: true },
      { id: 'ppl_home', name: 'PPL - doručení na adresu', short: 'PPL', carrier: 'ppl', point: false, price: 4.99, free: false },
      { id: 'gls_home', name: 'GLS - doručení na adresu', short: 'GLS', carrier: 'gls', point: false, price: 4.99, free: false }
    ]
  };

  var ATTR = {
    country: 'Doprava - země',
    method: 'Doprava',
    point: 'Výdejní místo',
    code: 'Výdejní místo - kód',
    carrier: 'Výdejní místo - dopravce',
    pay: 'Platba'
  };

  // Doprava se do objednávky přidává jako skrytý řádek (produkt "Doprava"), v pokladně je pak jediná sazba za 0 Kč.
  var SHIP_HANDLE = 'doprava-sluzba';
  var SHIP_VARIANTS = {
    zasilkovna:      { paid: 59240077820239, free: 59240077853007 },
    ppl_point:       { paid: 59240077885775, free: 59240077918543 },
    balikovna_point: { paid: 59240077951311, free: 59240077984079 },
    ppl_home:        { paid: 59240078016847 },
    balikovna_home:  { paid: 59240078049615 },
    gls_home:        { paid: 59271895941455 }
  };

  var mapScriptPromise = null;
  var syncing = false;

  var FEE_HANDLE = 'dobirka-poplatek';
  var FEE_VARIANT = 59240433647951;

  function syncShippingLine(wanted, removeIfNone, fee) {
    if (syncing) return;
    syncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var ship = cart.items.filter(function (i) { return i.handle === SHIP_HANDLE; });
      var feeLines = cart.items.filter(function (i) { return i.handle === FEE_HANDLE; });
      var others = cart.items.length - ship.length - feeLines.length;
      var target = others > 0 ? wanted : null;
      var shipChange;
      if (others === 0) shipChange = ship.length > 0;
      else if (target) shipChange = !(ship.length === 1 && ship[0].variant_id === target && ship[0].quantity === 1);
      else shipChange = !!removeIfNone && ship.length > 0;
      var feeWanted = others > 0 && !!fee;
      var feeChange = feeWanted ? !(feeLines.length === 1 && feeLines[0].quantity === 1) : feeLines.length > 0;
      if (!shipChange && !feeChange) { syncing = false; return; }
      var chain = Promise.resolve();
      var toAdd = [];
      function remove(i) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: i.key, quantity: 0 }) });
        });
      }
      if (shipChange) { ship.forEach(remove); if (target) toAdd.push({ id: target, quantity: 1 }); }
      if (feeChange) { feeLines.forEach(remove); if (feeWanted) toAdd.push({ id: FEE_VARIANT, quantity: 1 }); }
      if (toAdd.length) {
        chain = chain.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: toAdd }) });
        });
      }
      return chain.then(function () { window.location.reload(); });
    }).catch(function () { syncing = false; });
  }

  function loadMapScript() {
    if (mapScriptPromise) return mapScriptPromise;
    mapScriptPromise = new Promise(function (resolve, reject) {
      if (window.zslt && typeof window.zslt.openMap === 'function') return resolve();
      window.zslt = window.zslt || {};
      var s = document.createElement('script');
      s.id = 'zaslat-map';
      s.async = true;
      s.src = 'https://app.zaslat.cz/map/zaslat-map.umd.min.js';
      s.onload = function () { resolve(); };
      s.onerror = function () { mapScriptPromise = null; reject(new Error('map script')); };
      document.head.appendChild(s);
    });
    return mapScriptPromise;
  }

  function fmtPrice(country, value) {
    if (country === 'sk') return value.toFixed(2).replace('.', ',') + ' €';
    return Math.round(value) + ' Kč';
  }

  function isFree(root, country, m) {
    if (!m.free) return false;
    var total = parseInt(root.getAttribute('data-total'), 10) / 100;
    var cur = root.getAttribute('data-currency');
    if (country === 'sk') {
      // Slovensko: zdarma od 1 299 Kč (přepočteno aktuálním kurzem na eura)
      if (cur !== 'EUR') return false;
      var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '0');
      var threshold = rate > 0 ? 1299 * rate : 54;
      return total >= threshold;
    }
    return total >= 1299;
  }

  function pointText(p) {
    if (!p) return '';
    var name = p.name || p.title || '';
    var addr = '';
    if (typeof p.address === 'string') addr = p.address;
    else {
      var a = (p.address && typeof p.address === 'object') ? p.address : p;
      var street = a.street || '';
      var zipCity = [a.zip || a.postal_code || a.zip_code || '', a.city || a.town || ''].filter(Boolean).join(' ');
      addr = [street, zipCity].filter(Boolean).join(', ');
    }
    return [name, addr].filter(Boolean).join(', ');
  }

  function pointCode(p) {
    if (!p) return '';
    var c = p.code || p.id || p.branch_code || p.branchCode || p.pickup_branch || '';
    return String(c);
  }

  function updateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  function init(root) {
    if (root.getAttribute('data-k-ready')) return;
    root.setAttribute('data-k-ready', '1');

    var list = root.querySelector('[data-k-dlv-list]');
    var countrySel = root.querySelector('[data-k-dlv-country]');
    var msg = root.querySelector('[data-k-dlv-msg]');
    var attrs = {};
    try { attrs = JSON.parse(root.querySelector('[data-k-dlv-attrs]').textContent) || {}; } catch (e) {}

    var state = {
      country: attrs[ATTR.country] === 'sk' ? 'sk' : 'cz',
      methodId: null,
      pointText: attrs[ATTR.point] || '',
      pointCode: attrs[ATTR.code] || '',
      pay: attrs[ATTR.pay] === 'cod' ? 'cod' : 'online'
    };
    // země doručení se řídí trhem obchodu (SK trh = Slovensko), ať se nenabízí české dopravy v € košíku
    var marketMismatch = false;
    (function syncMarket() {
      var mk = window.Shopify && window.Shopify.country;
      var want = mk === 'SK' ? 'sk' : mk === 'CZ' ? 'cz' : null;
      if (want && want !== state.country) {
        state.country = want; state.pay = 'online';
        state.pointText = ''; state.pointCode = ''; attrs[ATTR.method] = '';
        marketMismatch = true;
      }
    })();
    var payList = root.querySelector('[data-k-pay-list]');
    // obnovení výběru z atributů (název metody → id)
    (function restore() {
      var saved = attrs[ATTR.method];
      if (!saved) return;
      var found = METHODS[state.country].filter(function (m) { return m.name === saved; })[0];
      if (found) state.methodId = found.id;
    })();
    countrySel.value = state.country;

    function current() {
      return METHODS[state.country].filter(function (m) { return m.id === state.methodId; })[0] || null;
    }

    function isReady() {
      var m = current();
      if (!m) return false;
      if (m.point && !state.pointCode) return false;
      return true;
    }

    function readyHint() {
      var m = current();
      if (!m) return 'Vyberte prosím způsob dopravy.';
      if (m.point && !state.pointCode) return 'Vyberte prosím výdejní místo.';
      return '';
    }

    function wantedVariant() {
      var m = current();
      if (!m || !isReady()) return null;
      var v = SHIP_VARIANTS[m.id];
      if (!v) return null;
      return (isFree(root, state.country, m) && v.free) ? v.free : v.paid;
    }

    function syncCheckout() {
      var ok = isReady();
      var btns = document.querySelectorAll('.cart__checkout-button, #checkout');
      btns.forEach(function (b) {
        b.classList.toggle('k-dlv-blocked', !ok);
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if (!ok) b.setAttribute('title', readyHint()); else b.removeAttribute('title');
      });
    }

    function showMsg(text) {
      if (!text) { msg.hidden = true; msg.textContent = ''; return; }
      msg.hidden = false; msg.textContent = text;
    }

    function render() {
      var methods = METHODS[state.country];
      list.innerHTML = '';
      methods.forEach(function (m) {
        var free = isFree(root, state.country, m);
        var selected = m.id === state.methodId;
        var el = document.createElement('div');
        el.className = 'k-dlv__item' + (selected ? ' is-selected' : '');
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', selected ? 'true' : 'false');
        el.setAttribute('tabindex', '0');
        var pickHtml = '';
        if (m.point) {
          if (selected && state.pointCode) {
            pickHtml = '<span class="k-dlv__picked">✓ ' + escapeHtml(state.pointText || ('Místo ' + state.pointCode)) + '</span> <a href="#" class="k-dlv__pick" data-k-pick>změnit</a>';
          } else {
            pickHtml = '<a href="#" class="k-dlv__pick" data-k-pick>Zvolte odběrné místo</a>';
          }
        }
        el.innerHTML =
          '<span class="k-dlv__radio"></span>' +
          '<span class="k-dlv__main"><strong class="k-dlv__name">' + escapeHtml(m.name) + '</strong>' +
          (pickHtml ? '<span class="k-dlv__sub">' + pickHtml + '</span>' : '') + '</span>' +
          '<span class="k-dlv__carrier">' + (root.getAttribute('data-logo-' + (m.logo || m.carrier)) ? '<img src="' + escapeHtml(root.getAttribute('data-logo-' + (m.logo || m.carrier))) + '" alt="' + escapeHtml(m.short) + '" loading="lazy">' : escapeHtml(m.short)) + '</span>' +
          '<span class="k-dlv__price' + (free ? ' is-free' : '') + '">' + (free ? 'ZDARMA' : fmtPrice(state.country, m.price)) + '</span>';

        el.addEventListener('click', function (ev) {
          var pick = ev.target.closest('[data-k-pick]');
          if (pick) ev.preventDefault();
          selectMethod(m, !!pick || (m.point && !state.pointCode));
        });
        el.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); selectMethod(m, m.point && !state.pointCode); }
        });
        list.appendChild(el);
      });
      renderPay();
      syncCheckout();
    }

    function renderPay() {
      if (!payList) return;
      var opts = [
        { id: 'online', name: 'Kartou, Apple Pay / Google Pay nebo bankovním převodem', price: 'bez poplatku' }
      ];
      if (state.country === 'cz') opts.push({ id: 'cod', name: 'Dobírka (platba při převzetí)', price: '+ 39 Kč' });
      if (state.pay === 'cod' && state.country !== 'cz') state.pay = 'online';
      payList.innerHTML = '';
      opts.forEach(function (o) {
        var selected = state.pay === o.id;
        var el = document.createElement('div');
        el.className = 'k-dlv__item' + (selected ? ' is-selected' : '');
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', selected ? 'true' : 'false');
        el.setAttribute('tabindex', '0');
        el.innerHTML = '<span class="k-dlv__radio"></span><span class="k-dlv__main"><strong class="k-dlv__name">' + escapeHtml(o.name) + '</strong></span>' +
          '<span class="k-dlv__price">' + escapeHtml(o.price) + '</span>';
        function pick() { if (state.pay === o.id) return; state.pay = o.id; renderPay(); save(); }
        el.addEventListener('click', pick);
        el.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); pick(); } });
        payList.appendChild(el);
      });
    }

    function save() {
      var p = saveAttrs();
      return p.then(function (r) { syncShippingLine(wantedVariant(), state.country === 'sk', state.pay === 'cod' && state.country === 'cz'); return r; });
    }

    function saveAttrs() {
      var m = current();
      var a = {};
      a[ATTR.country] = state.country;
      a[ATTR.method] = m ? m.name : '';
      a[ATTR.point] = (m && m.point) ? state.pointText : '';
      a[ATTR.code] = (m && m.point) ? state.pointCode : '';
      a[ATTR.carrier] = (m && m.point) ? m.carrier : '';
      a[ATTR.pay] = (state.pay === 'cod' && state.country === 'cz') ? 'cod' : 'online';
      return updateAttributes(a);
    }

    function selectMethod(m, openMap) {
      if (state.methodId !== m.id) {
        state.methodId = m.id;
        state.pointText = ''; state.pointCode = '';
      }
      showMsg('');
      render();
      save();
      if (m.point && openMap) openPointMap(m);
    }

    function openPointMap(m) {
      loadMapScript().then(function () {
        var prices = {};
        prices[m.carrier] = isFree(root, state.country, m) ? 'ZDARMA' : fmtPrice(state.country, m.price);
        return window.zslt.openMap({
          addressType: 'recipient',
          territory: state.country,
          carriers: [m.carrier],
          lang: 'cz',
          prices: prices,
          style: { colorPrimary: '#3A2FA8' },
          value: state.pointCode || null
        });
      }).then(function (point) {
        if (!point) return;
        if (window.console) console.log('[k-dlv] vybrané místo', point);
        var code = pointCode(point);
        if (!code) { showMsg('Výdejní místo se nepodařilo načíst, zkuste to prosím znovu.'); return; }
        state.pointCode = code;
        state.pointText = pointText(point);
        showMsg('');
        render();
        save();
      }).catch(function () {
        showMsg('Mapu výdejních míst se nepodařilo načíst. Zkuste to prosím znovu.');
      });
    }

    countrySel.addEventListener('change', function () {
      state.country = countrySel.value === 'sk' ? 'sk' : 'cz';
      // ceny a doprava se řídí trhem (Česko = Kč, Slovensko = €), takže přepneme i trh obchodu
      var want = state.country === 'sk' ? 'SK' : 'CZ';
      var have = window.Shopify && window.Shopify.country;
      if (have && have !== want) {
        state.methodId = null; state.pointText = ''; state.pointCode = '';
        var a0 = {};
        a0[ATTR.country] = state.country; a0[ATTR.method] = ''; a0[ATTR.point] = ''; a0[ATTR.code] = ''; a0[ATTR.carrier] = ''; a0[ATTR.pay] = 'online';
        updateAttributes(a0).then(function () {
          var f = document.createElement('form');
          f.method = 'post'; f.action = '/localization';
          [['form_type', 'localization'], ['_method', 'put'], ['country_code', want], ['return_to', '/cart']].forEach(function (kv) {
            var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
          });
          document.body.appendChild(f); f.submit();
        });
        return;
      }
      state.methodId = null; state.pointText = ''; state.pointCode = '';
      showMsg('');
      render();
      save();
    });

    // záloha: bez výběru nejde do pokladny (stav se bere z poslední inicializace)
    window.__kDlv = { isReady: isReady, hint: readyHint, show: showMsg, list: list };
    var form = document.getElementById('cart');
    if (form && !form.getAttribute('data-k-guard')) {
      form.setAttribute('data-k-guard', '1');
      form.addEventListener('submit', function (ev) {
        var g = window.__kDlv;
        var submitter = ev.submitter;
        if (g && submitter && submitter.name === 'checkout' && !g.isReady()) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          g.show(g.hint());
          g.list.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    render();
    if (marketMismatch) save();
    syncShippingLine(wantedVariant(), state.country === 'sk', state.pay === 'cod' && state.country === 'cz');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function scan() {
    document.querySelectorAll('[data-k-dlv]').forEach(init);
  }

  scan();
  // Dawn po změně množství přerenderuje části košíku, takže po každé změně DOM znovu vložíme výběr
  new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
})();
